import { positionFeedEventSchema, type PositionFeedEvent } from '@chukua/common';

/** The data of a `positions` event on the tracking stream, or undefined for anything that is not one. */
export function parsePositionFeedEvent(data: string): PositionFeedEvent | undefined {
  try {
    const parsed = positionFeedEventSchema.safeParse(JSON.parse(data));
    return parsed.success ? parsed.data : undefined;
  } catch {
    return undefined;
  }
}
